import React, { useEffect, useState } from "react";
import { Card, Tabs, Row, Col, Typography, Progress, Spin, Button } from "antd";
import { LineChartOutlined } from "@ant-design/icons";
import { FaClipboardList } from "react-icons/fa";
import { MdOpenInNew } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../slice";
import * as selectors from "../selectors";
const { TabPane } = Tabs;
const { Text, Title } = Typography;

const BarList = ({ data }) => {
  const maxValue = Math.max(
    ...data
      .map((d) => d.count)
      .filter((count) => count != null && count !== undefined)
  );
  return (
    <div>
      {data?.map((item, index) => (
        <div key={index} style={{ marginBottom: 15 }}>
          <Text
            style={{
              fontSize: 14,
              fontWeight: 500,
              color: "#333",
              display: "block",
            }}
          >
            {item.name}
          </Text>
          <Row style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Col flex="auto">
              <Progress
                percent={(item.count / maxValue) * 100}
                showInfo={false}
                strokeColor="#1C8A7A"
                strokeLinecap="round"
                strokeWidth={15}
              />
            </Col>
            <Col flex="none">
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#fff",
                  backgroundColor: "#1C8A7A",
                  borderRadius: "50%",
                  padding: "2px 8px",
                  display: "inline-block",
                  minWidth: 28,
                  textAlign: "center",
                }}
              >
                {item.count}
              </Text>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

const DataNotFound = () => (
  <div
    style={{
      minHeight: 625,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div
      style={{
        fontSize: "48px",
        marginBottom: "16px",
        color: "#d9d9d9",
      }}
    >
      <FaClipboardList color="#1C8A7A" />
    </div>
    <Title level={4} style={{ color: "#8c8c8c", marginBottom: 8 }}>
      No Commodity Wise Orders Found
    </Title>
    <Text type="secondary" style={{ fontSize: "14px" }}>
      No commodity wise orders found in the selected period.
    </Text>
  </div>
);

const CommodityWiseOrders = ({
  selectedCommodities,
  dateRange,
  selectedDatePeriod,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [activeKey, setActiveKey] = useState("top");
  const [isLoading, setIsLoading] = useState(true);
  const commodityWiseOrders = useSelector(selectors.selectCommodityWiseOrders);

  const handleDetailedView = () => {
    history.push("/labPortal/dashboard/details/commodityOrder", {
      selectedCommoditiesFilter: selectedCommodities,
      dateRangeFilter: dateRange,
      selectedDatePeriodFilter: selectedDatePeriod,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      actions.getCommodityWiseOrders({
        view: activeKey,
        selectedCommodities,
        dateRange,
        onSuccess: () => {
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, selectedCommodities, dateRange, activeKey]);

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#fff",
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          <LineChartOutlined style={{ marginRight: 8 }} />
          Commodity wise Orders
        </div>
      }
      headStyle={{
        backgroundColor: "#1C8A7A",
        borderBottom: "none",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
      bodyStyle={{ padding: "16px 20px" }}
      style={{ borderRadius: 8, overflow: "hidden", minHeight: 770 }}
      extra={
        <Button
          type="ghost"
          onClick={handleDetailedView}
          style={{
            fontWeight: 600,
            color: "#fff",
            borderColor: "#fff",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <MdOpenInNew size={14} />
          Detailed View
        </Button>
      }
    >
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        type="card"
        tabBarGutter={0}
        tabBarStyle={{ marginBottom: 20 }}
      >
        <TabPane
          tab={<span style={{ fontWeight: 500 }}>Top 10</span>}
          key="top"
        >
          {isLoading ? (
            <div
              style={{
                minHeight: 600,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 24,
              }}
            >
              <Spin size="large" />
            </div>
          ) : commodityWiseOrders?.length === 0 ? (
            <DataNotFound />
          ) : (
            <BarList data={commodityWiseOrders} />
          )}
        </TabPane>
        <TabPane
          tab={<span style={{ fontWeight: 500 }}>Bottom 10</span>}
          key="bottom"
        >
          {isLoading ? (
            <div
              style={{
                minHeight: 600,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 24,
              }}
            >
              <Spin size="large" />
            </div>
          ) : commodityWiseOrders?.length === 0 ? (
            <DataNotFound />
          ) : (
            <BarList data={commodityWiseOrders} />
          )}
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default CommodityWiseOrders;
